import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { DsIconsService } from "./ds-icons.service";
import { SvgIconClipPathInterceptor } from "./svg-clip-path.interceptor";

export function initIcons(dsIcons: DsIconsService) {
  return () => {};
}

@NgModule({
  providers: [
    DsIconsService,
    {
      provide: APP_INITIALIZER,
      useFactory: initIcons,
      deps: [DsIconsService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SvgIconClipPathInterceptor,
      multi: true,
    },
  ],
})
export class DsIconsModule {}
